module.exports = (window.__publicpath__ || __webpack_public_path__) + "static/media/191to1.0842ddd6.jpg";